export const shouldHideOrderGrinKitsPrice = ({ canClinicBuyScopes, products = [] }) => {
  if (!canClinicBuyScopes) {
    return true
  }

  return products.every(({ price = 0 }) => Number(price) <= 0)
}

export const getOrderGrinKitsAmountStepProducts = ({ hasFreeScopes, products = [] }) => {
  if (!hasFreeScopes) {
    return products
  }

  return products.map(product => ({ ...product, price: 0, previousPrice: null }))
}
